<script setup lang="ts">
import Button from '@/core/components/base/Button.vue'
import { useButtonScrollup, useButtonScrollupMock } from './ButtonScrollup'

const { disabled, doScrollUp } = useButtonScrollup()

function handleTap(event: PointerEvent) {
  doScrollUp()
}
</script>

<template>
  <Button class="button-scrollup" :disabled @tap="handleTap">
    <template #default><img src="/images/simakatra/arrow-up.gif" /></template>
    <template #disabled><img src="/images/simakatra/arrow-up-disable.png" /></template>
  </Button>
</template>

<style scoped>
.button-scrollup {
  position: absolute;
  top: 465px;
  left: 653px;
}
</style>
